import { createContext, useContext, useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signOut
} from "firebase/auth";
import { auth } from "../components/Firebase";

const userAuthContext = createContext();

export function UserAuthContextProvider({ children }) {
  const [user, setUser] = useState({});
  const [token, setToken] = useState("test");

  function logIn(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }
  
  function createUser(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
  }
  
  function logOut() {
    return signOut(auth);
  }

  function resetPassword(email){
    return sendPasswordResetEmail(auth, email,{
      url: 'https://zerowastenus.izeesync.com/'
    })
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentuser) => {
      setToken(currentuser.accessToken)
      setUser(currentuser);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <userAuthContext.Provider
      value={{ user, token, logIn, createUser, logOut, resetPassword }}
    >
      {children}
    </userAuthContext.Provider>
  );
}

export function useUserAuth() {
  return useContext(userAuthContext);
}